
import { orderService } from '../../services/orderService';
import { Order } from '../../types/Order';
import useDataById from '../core/useDataById';

export  function useOrder({ id }: { id: string }) {
    const {
        data: order,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Order>({ service: {
        ...orderService,
        ...orderService.baseService
    }, id });

    return {
     order,
     error,
     loading,
     deleteOrder: deleteItem,
     updateOrder: updateItem,
    }

}
